export default __webpack_public_path__ + "static/ProximaNova-Regular-0dc165b63070be6600e6b1dea75f1f32.woff2";